module.exports = __webpack_public_path__ + "media/images/landing/bg/screens-crm/01-158968a8cfef8bf5f500a30780b2a0d7.png";